import { type VariantProps, cva } from 'class-variance-authority';
import type { ReactNode } from 'react';

import { cn } from '@/design-system/lib/cn';
import { type Tone, toneStyle } from '@/design-system/lib/tone';

const tileVariants = cva('grid shrink-0 place-items-center [&_svg]:stroke-[1.8]', {
  variants: {
    tone: {
      primary: 'bg-primary-soft text-primary',
      sky: 'bg-accent-sky-soft text-accent-sky',
      purple: 'bg-accent-purple-soft text-accent-purple',
      pink: 'bg-accent-pink-soft text-accent-pink',
      amber: 'bg-warning-soft text-accent-amber',
      success: 'bg-status-complete-bg text-success',
      danger: 'bg-status-conflict-bg text-danger',
      warning: 'bg-status-partial-bg text-status-partial',
      neutral: 'bg-surface-muted text-ink-secondary',
      ai: 'bg-ai text-white',
      custom: 'bg-tone-tint text-tone',
    },
    size: {
      xs: 'size-6.5 rounded-chip [&_svg]:size-3.5',
      sm: 'size-8 rounded-control-sm [&_svg]:size-4',
      md: 'size-9 rounded-control [&_svg]:size-4.5',
      lg: 'size-11 rounded-block [&_svg]:size-5',
      xl: 'size-12 rounded-block [&_svg]:size-5',
    },
  },
  defaultVariants: { tone: 'primary', size: 'lg' },
});

export type IconTileProps = VariantProps<typeof tileVariants> & {
  children: ReactNode;
  /** Cor e fundo quando são dado (cor do ministério ou da série), com o par escuro. */
  palette?: Tone;
  className?: string;
};

/** Quadrado arredondado com ícone colorido (KPI, estado vazio, ministério). */
export function IconTile({ tone, size, palette, className, children }: IconTileProps) {
  return (
    <span
      aria-hidden
      className={cn(tileVariants({ tone: palette ? 'custom' : tone, size }), className)}
      style={palette ? toneStyle(palette) : undefined}
    >
      {children}
    </span>
  );
}
